import {useCallback, useMemo} from "react";
import fetchData from "../api/fetch-suspense-wrapper/FetchSuspenseWrapper";
import {getQueryResults} from "../api/duckdb/getQueryResults";
import {createKeyToValueDictionary} from "../utils/Utils";

/**
 * Pobieranie wielu zapytań
 * @param {Array<{SQL: string, ClientQueryID: string, Parameters?: Record<string, any>}>} queries Lista zapytań do wywołania
 * @returns
 */
export default function useMultiQueryCallerResource(queries) {
    const fetchQueries = useCallback(async () => {
        const res = await getQueryResults({
            Queries: queries,
        });
        const result = createKeyToValueDictionary(
            res.QueriesResults,
            "ResultID"
        );
        return result;
    }, [queries]);

    return useMemo(() => {
        return fetchData(fetchQueries());
    }, [fetchQueries]);
}
